import { FlatObject } from '../types/commonTypes.ts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getQueryParams = (obj: FlatObject<any>) =>
  new URLSearchParams(Object.entries(obj).map(([key, value]) => [key, JSON.stringify(value)])).toString();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapEachEntry = <T = any>(sourceObject: FlatObject<T>, mapFn: (entry: [string, any]) => [string, T]) =>
  Object.fromEntries(Object.entries(sourceObject).map(mapFn));
